import { Vector3 } from 'three';

import { NavMeshQuery } from '@recast-navigation/core';

export const isPointInNavMesh = (position: Vector3, navMeshQuery?: NavMeshQuery) => {
  if (navMeshQuery) {
    const result = navMeshQuery.findClosestPoint(position, {
      halfExtents: { x: 1, y: 1, z: 1 },
    });
    return result.success && result.isPointOverPoly;
  } else {
    return true;
  }
};
